// export const API_URL = 'https://api.goldenpharma.octopharma.net/api';
// export const API_URL = 'https://api.oubari.octopharma.net/api';
// export const API_URL = 'https://mirror-api.octopharma.net/api';
// export const API_URL = 'https://mirta-mirror-api.octopharma.net/api';
// export const API_URL = 'https://api.ibn-alhaytham.octopharma.net/api';
// export const API_URL = 'https://alradwan-mirror-api.octopharma.net/api';
// export const API_URL = 'https://api.alradwan.octopharma.net/api';
// export const API_URL = 'https://api.media-pharma.octopharma.net/api'
// export const API_URL = 'https://olabi-mirror-api.octopharma.net/api'
// export const API_URL = 'https://api.alkhalil.octopharma.net/api'
// export const API_URL = 'https://olabi-mirror-api.octopharma.net/api'
// export const API_URL = 'https://mirror2-api.octopharma.net/api'
// export const API_URL = 'https://api.ibn-alhaytham.octopharma.net/api'
// export const API_URL = 'https://api.ibn-alhaytham.octopharma.net/api'
// export const API_URL = 'https://new-api.ramapharma-sy.com/api'

// export const API_URL = 'https://api.olabi.octopharma.net/api'
export const API_URL = 'https://api.mirta.octopharma.net/api'

// export const API_URL = 'https://right-med-api.octopharma.net/api'

export const VERSION = '3.9.0';
